module.exports = __webpack_public_path__ + "static/media/AXMATIC-DMAGIC-SLP-logo.9eca6aef.png";